export interface HasD2 {
  d2: number
}

export function byD2Desc(a: HasD2, b: HasD2) {
  return b.d2 - a.d2
}

export function byD2Asc(a: HasD2, b: HasD2) {
  return a.d2 - b.d2
}